var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';

const PayPalDonateLink = ({ paypalid, classname, children, currency, amount }) => {
  const amountParam = amount ? `&amount=${amount}` : '';
  const url = `https://www.paypal.com/cgi-bin/webscr?cmd=_donations&business=${paypalid}&currency_code=${currency}${amountParam}&source=url`;
  classname += ' paypal-donate';
  return /*#__PURE__*/(
    _jsx(Link, { className: classname, href: url, target: "_blank", rel: "noreferrer noopener" }, void 0,
    children
    ));

};

PayPalDonateLink.defaultProps = {
  children: '',
  classname: '',
  amount: null
};













export default PayPalDonateLink;